import Rollbar from 'rollbar';

interface RollbarTraceException {
  message?: string;
}

interface RollbarTrace {
  exception?: RollbarTraceException;
}

interface RollbarBody {
  trace?: RollbarTrace;
  message?: {
    body?: string;
  };
}

interface RollbarPayload {
  request?: {
    headers?: Record<string, string>;
  };
  [key: string]: unknown;
}

const rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  environment: import.meta.env.VITE_APP_ENV,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: ['production', 'staging'].includes(import.meta.env.VITE_APP_ENV),
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        code_version: import.meta.env.VITE_APP_VERSION || 'unknown',
      },
    },
  },
  transform: (payload: RollbarPayload) => {
    if (!payload?.request) {
      return;
    }

    const headers = payload.request.headers;

    if (headers) {
      if (headers.Authorization) {
        headers.Authorization = '[REDACTED]';
      }

      if (headers.Cookie) {
        headers.Cookie = '[REDACTED]';
      }
    }
  },
});

rollbar.configure({
  checkIgnore: (_isUncaught, _args, payload) => {
    const body = payload?.body as RollbarBody | undefined;

    const message = body?.trace?.exception?.message ?? body?.message?.body;

    if (typeof message !== 'string') {
      return false;
    }

    const isResizeObserverError = message.includes(
      'ResizeObserver loop completed with undelivered notifications'
    );

    const isServiceWorkerAbortError =
      (message.includes('Failed to update a ServiceWorker') &&
        message.includes('Operation has been aborted')) ||
      message.includes('newestWorker is null');

    const isMaskedScriptError = message.includes('Script error');

    return isResizeObserverError || isServiceWorkerAbortError || isMaskedScriptError;
  },
});

export default rollbar;
